// removed by extract-text-webpack-plugin
module.exports = {"root":"_CU_bQ","container":"_28you","header":"_2NGax","loader":"_1gcM7"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/QuizBlock.scss
// module id = 1175
// module chunks = 2